export const Shape = {
    CUBE: 1,
    SPHERE: 2
  }